/* eslint-disable @typescript-eslint/ban-types */
export default class ObjectUtil {
  /**
   * 获取类的名字
   * @param obj -- 类实例
   */
  public static getName(obj: Object): string {
      return obj.constructor.name;
  }

  /**
     * 获取方法的名称
     * @param obj --- 方法名称
     */
  public static getFuncName(obj: Function): string {
    return obj.name;
  }

  /**
  * 判断是不是对象
  * @param {*} obj: any --- 需要判断的对象
  * @return {*} boolean --- 是对象 ： true, 不是对象: false
  */
  public static isObject(obj: any) {
    return Object.prototype.toString.call(obj) === '[object Object]'
  }

  /**
  * 判断是不是数组
  * @param {*} arr: any --- 需要判断的对象
  * @return {*} boolean --- 是数组 ： true, 不是数组: false
  */
  public static isArray(arr: any): boolean {
    return Object.prototype.toString.call(arr) === '[object Array]'
  }

  /**
  * 判断是不是字符串
  * @param {*} arr: any --- 需要判断的对象
  * @return {*} boolean --- 是数组 ： true, 不是数组: false
  */
  public static isString(val: any): boolean {
    return Object.prototype.toString.call(val) === '[object String]'
  }
}